import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Zap, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back.");
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Login failed.");
        } finally {
            setLoading(false);
        }
    };

    const inputCls = "w-full bg-white/5 border border-white/15 rounded-md px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:ring-2 focus:ring-cyan focus:border-transparent transition-shadow";

    return (
        <div className="min-h-screen bg-obsidian text-white grain relative flex items-center justify-center px-6">
            <div className="relative z-10 w-full max-w-sm">
                <Link to="/" className="inline-flex items-center bg-white rounded-md px-3 py-2 mb-10">
                    <img src="/korhc-logo.png?v=4" alt="KORHC" className="h-8 w-auto" />
                </Link>
                <div className="eyebrow text-cyan mb-3">Admin access</div>
                <h1 className="font-heading font-black text-4xl tracking-tight leading-none mb-10">Sign in.</h1>
                <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
                    <div>
                        <label className="eyebrow text-white/50 block mb-2">Email</label>
                        <input data-testid="login-email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@korhc.com" />
                    </div>
                    <div>
                        <label className="eyebrow text-white/50 block mb-2">Password</label>
                        <input data-testid="login-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
                    </div>
                    <button type="submit" disabled={loading} data-testid="login-submit-button"
                        className="group eyebrow w-full inline-flex items-center justify-center gap-2 rounded-full bg-cyan text-obsidian px-8 py-4 hover:-translate-y-0.5 transition-transform duration-300 disabled:opacity-50">
                        {loading ? "Signing in…" : "Sign in"} <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                    </button>
                </form>
            </div>
        </div>
    );
}
